const useStyles = () => ({
  file: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px',
    pr: '36px',
    gap: '4px',
    borderRadius: '4px',
    background: '#FFF',
    cursor: 'pointer',
    position: 'relative',
    height: 'auto',
    overflow: 'hidden',
  },
  rowContainer: {
    display: 'flex',
    gap: '12px',
  },
  fileNameWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  fileName: {
    fontSize: '14px',
    fontWeight: 700,
    color: '#252525',
    textTransform: 'uppercase',
  },
  fileSize: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#808080',
  },
  removeBtn: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
});

export default useStyles;
